<template>
    <div :class="classNames">
        <template v-if="$route.name == 'EditSystemInfo' || $route.name == 'CreateSystem'">
            <div :class="classNames+ '_title'">操作员信息</div>
            <el-form :model="ruleForm" status-icon :rules="rules" ref="resetPass" label-width="100px" label-position="left">
                <el-form-item label="姓名" prop="name">
                    <div class="el-form-item-content">
                        <el-input :clearable="true" v-model="ruleForm.name" placeholder="请输入姓名" :class="classNames+ '_inp'">
                        </el-input>
                    </div>
                </el-form-item>
                 <el-form-item label="登录账号" prop="account">
                    <div class="el-form-item-content">
                        <el-input :clearable="true" v-model="ruleForm.account" placeholder="请输入登录账号" :class="[classNames+ '_inp']">
                        </el-input>
                    </div>
                </el-form-item>
                <el-form-item :label="$route.name == 'CreateSystem'?'登录密码':'修改密码'" prop="password">
                    <div class="el-form-item-content">
                        <el-input auto-complete="new-password" :clearable="true" type="password" v-model="ruleForm.password" placeholder="请输入6-12位的字母或者数字组合" show-password autocomplete="off" :class="[classNames+ '_inp']">
                            <img slot="prefix" src="../../assets/image/lock.png" alt="" />
                        </el-input>
                    </div>
                </el-form-item>
                <el-form-item v-if="$route.name == 'CreateSystem'" label="确认密码" prop="confirm_password">
                    <div class="el-form-item-content">
                        <el-input auto-complete="new-password" :clearable="true" type="password" v-model="ruleForm.confirm_password" placeholder="请再次输入密码"  autocomplete="off" show-password :class="[classNames+ '_inp']">
                            <img slot="prefix" src="../../assets/image/lock.png" alt="" />
                        </el-input>
                    </div>
                </el-form-item>
                <el-form-item label="所属二维码标题 (指销售姓名)" prop="sms_obj_ids" class="select-qrcode-item">
                    <el-select @change="onqrcodeTileListValueChange" v-model="qrcodeTileListValue" multiple placeholder="请选择">
                        <el-option
                        v-for="item in qrcodeTileList"
                        :key="item.id"
                        :label="`ID${item.id}: ${item.title || '(空)'}`"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="tip-text">选择二维码标题后，登陆该子账号在线索管理页面只能看到对应二维码标题的线索数据，若要查看全部数据默认为空即可。</div>
                </el-form-item>
		    </el-form>
        </template>
        <template v-if="$route.name == 'EditSystem' || $route.name == 'CreateSystem'">
            <div :class="classNames+ '_title'">权限设置（请勾选该角色可以操作的模块）</div>
            <div class="check_checkAll">
				<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
			</div>
			<div class="check_checkList">
				<check-group :list="list" @getSelectValues="getSelectValues" :selectList="selectList" :editNameObj="editNameObj" @getCheckAllStatus="getCheckAllStatus" ref="checkGroup" v-if="list.length"></check-group>
			</div>
            
        </template>
        <el-button type="primary" @click="submitForm('resetPass')">{{ $route.name !='CreateSystem'? '确认' : '确认添加'}}</el-button>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name: 'CreateSystem',
    data() {
        let validateNew_password = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'))
            } else {
                let rule = /^[a-z|A-Z|0-9]{6,12}$/
                if (!rule.test(value)) {
                    callback(new Error('您输入的密码不符合规则，请重新输入'))
                }
                callback()
            }
        }
        let validateNew_passwordTwo = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else {
                if (value !== this.ruleForm.password) {
                    callback(new Error('两次输入的密码不一样，请重新输入'))
                }
                callback()
            }
        }
        let validate_account = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('输入登录账号'))
            } else {
                let rule = /^[a-z|A-Z]{6,15}$/
                if (!rule.test(value)) {
                    callback(new Error('登录账号为6-15位的字母'))
                }
                callback()
            }
        }
        // 校验修改密码
        let validateChange_password = (rule, value, callback) => {
            if (value === '') {
                callback()
            } else {
                let rule = /^[a-z|A-Z|0-9]{6,12}$/
                if (!rule.test(value)) {
                    callback(new Error('您输入的密码不符合规则，请重新输入'))
                }
                callback()
            }
        }
        let getPasswordValidateObj = ()=>{
            if(this.$route.name == 'CreateSystem'){ // 添加 新子账号 时
                return {
                    validator: validateNew_password,
                    required: true,
                    trigger: 'blur'
                }
            }else{ // 编辑时
                return {
                    validator: validateChange_password,
                    required: false,
                    trigger: 'blur'
                }
            }
        }
        return {
            classNames: 'createSystem',
            checkAll: false,
            isIndeterminate: false,
            selectList: [],
            editNameObj: {
                label: 'name',
                value: 'id'
            },
            ruleForm: {
                name: '',
                account: '',
                password: '', // 添加 和 编辑修改的密码
                confirm_password: '', // 添加时 确认密码
                sms_obj_ids: '' //选中的二维码标题id, 多个用逗号连接
            },
            rules: {
                name: [{
                    required: true,
                    message: '请输入姓名',
                    trigger: 'blur'
                }],
                account: [
                    {
                        validator: validate_account,
                        required: true,
                        trigger: 'blur'
                    }
                ],
                password: [getPasswordValidateObj()],
                confirm_password: [{
                    validator: validateNew_passwordTwo,
                    required: true,
                    trigger: 'blur'
                }],
                // sms_obj_ids: [{
                //     required: true,
                //     message: '请选择所属二维码标题',
                //     trigger: 'change'
                // }]
            },
            list: [],
            qrcodeTileList: [],// 所属二维码标题 总列表
            qrcodeTileListValue: []// 选中 所属二维码标题id列表
        }
    },
    async created() {
        this.getPermission()
        this.getPrivateQrcode()
        if(this.$route.params.id) {
            this.getAccountInfoFun()
        }
    },
    components: {
        'check-group': {
            name: 'check-group',
            props: {
                list: {
                    type: Array,
                    default: () => []
                },
                dataObj: {
                    type: Object,
                    default: () => {}
                },
                selectList: {
                    type: Array,
                    default: () => []
                },
                editNameObj: {
                    type: Object,
                    default: () => {
                        return {
                            label: 'name',
                            value: 'id'
                        }
                    }
                },
                checkedStatusList: {
                    type: Array,
                    default: () => []
                }
            },
            data() {
                return {
                    // selectList: []
                }
            },
            created() {
                // console.log(this.dataObj)
                // console.log(this.selectList)
            },
            methods: {
                selectListFun(data) {
                    if(data.checked || data.indeterminate) {
                        !this.selectList.includes(data.value) ? this.selectList.push(data.value) : '' 
                    } else {
                        let index = this.selectList.findIndex(obj => obj == data.value)
                        index >= 0 ?  this.selectList.splice(index, 1): ''
                    }
                },
                changeparent(value,item) {
                    if(item) {
                        this.changeChecked(item.children, value)
                    }
                    if(this.dataObj) {
                        let checked = this.dataObj.children.every(item => item.checked)
                        let indeterminate = checked ? false :this.dataObj.children.some(item => item.checked || item.indeterminate)
                        this.$set(this.dataObj, 'checked', checked)
                        this.$set(this.dataObj, 'indeterminate', indeterminate)
                        // this.selectListFun(this.dataObj)
                        this.$emit('changeparent', value, item)
                    }
                    if(item) {
                        this.$set(item, 'indeterminate', false)
                        // this.selectListFun(item)
                        this.$emit('getSelectValues')
                    }

                },
                changeChecked(data, value) {
                    data.forEach(item => {
                        // this.selectListFun(item)
                        if(value) {
                            this.$set(item, 'indeterminate', false)
                        }
                        this.$set(item, 'checked', value)
                        if(item.children) {
                            this.changeChecked(item.children, value)
                        }
                    })
                },
                changeChild(value, item) {
                    if(this.dataObj) {
                        let checked = this.dataObj.children.every(item => item.checked)
                        let indeterminate = checked ? false : this.dataObj.children.some(item => item.checked || item.indeterminate)
                        this.$set(this.dataObj, 'checked', checked)
                        this.$set(this.dataObj, 'indeterminate', indeterminate)
                        this.$emit('changeChild', value, item)
                    }
                    this.$emit('getSelectValues')
                    // console.log(this.dataObj, 'ooododso')
                },
                selectAll(type) {
                    this.list.forEach(item => {
                        this.$set(item, 'checked', type)
                        if(item.children) {
                            this.changeChecked(item.children,type)
                        }
                    })
                    this.$emit('selectAll', type)
                    this.$emit('getSelectValues')
                }
            },
            watch: {
                selectList: {
                    deep: true,
                    immediate: true,
                    handler(news) {
                        if(!news.length) {
                            return
                        }
                        this.list.forEach(item => {
                            this.$set(item, 'checked', false)
                            if(news.includes(item[this.editNameObj.value])) {
                                this.$set(item, 'checked', true)
                            }
                        })
                        if(this.dataObj) {
                            let checked = this.dataObj.children.every(item => item.checked)
                            let indeterminate = checked ? false :this.dataObj.children.some(item => item.checked || item.indeterminate)
                            // console.log(checked, indeterminate, '..indeterminate')
                            this.checkedStatusList.push({checkAll: checked, indeterminate: indeterminate})
                            this.$set(this.dataObj, 'checked', checked)
                            this.$set(this.dataObj, 'indeterminate', indeterminate)
                            this.$emit('getCheckAllStatus', this.checkedStatusList)
                        }
                    }
                }
            },
            render() {
                let list = this.list
                return (
                    <div class="checkbox_group">
                        {
                            list.map(item => {
                                if(!item.children) {
                                    return <el-checkbox v-model={item.checked} key={item[this.editNameObj.value]} onChange={(value) => this.changeChild(value, item)}>{item[this.editNameObj.label]}</el-checkbox>
                                } else {
                                    return (
                                        <div class="checkbox_group_con" key={item[this.editNameObj.value]}>
                                            <el-checkbox indeterminate={item.indeterminate} v-model={item.checked} onChange={(value) => {this.changeparent(value, item)}}>{item[this.editNameObj.label]}</el-checkbox>
                                            <check-group list={item.children} onChangeChild={this.changeChild} dataObj={item} onChangeparent={this.changeparent} ongetSelectValues={this.getSelectValues} selectList={this.selectList} editNameObj={this.editNameObj} onSelectAll={this.selectAll} checkedStatusList={this.checkedStatusList} onGetCheckAllStatus={this.getCheckAllStatus}></check-group>
                                        </div>
                                    )
                                }
                            })
                            
                        }
                    </div>
                )
            }
        }
    },
    methods: {
        ...mapActions('permission', ['addAccount', 'permission', 'getAccountInfo', 'editPermission', 'editAccount']),
        ...mapActions('message', ['privateQrcode']),
        // 获取 所属二维码标题
        async getPrivateQrcode(){
            let res = await this.privateQrcode({params:{type: 1, with_empty_title: 1}})
            this.qrcodeTileList = res
            if(!this.$route.params.id){
                this.qrcodeTileListValue = res.map((item)=> item.id ) || []
                this.onqrcodeTileListValueChange()
            }
        },
        handleCheckAllChange(value) {
            this.$refs.checkGroup.selectAll(value)
        },
        // 改变 所属二维码标题
        onqrcodeTileListValueChange(){
            this.ruleForm.sms_obj_ids = this.qrcodeTileListValue.join(',')
        },
        // 回显 所属二维码标题
        reViewQrcodeTileListValue(){
            if(this.ruleForm.sms_obj_ids){
                this.qrcodeTileListValue = this.ruleForm.sms_obj_ids.split(',').map((item) => parseInt(item))
            }
        },
        getSelectValues() {
            let arr = []
           let selectListFun = (data) => {
               data.forEach(item => {
                    if(item.checked || item.indeterminate) {
                       arr.includes(item[this.editNameObj.value])? '': arr.push(item[this.editNameObj.value])
                    }
                    if(item.children) {
                        selectListFun(item.children)
                    }
               })
           }
           selectListFun(this.list)
           this.selectList = arr
        },
        async getPermission() {
            let res = await this.permission()
            this.list = res
        },
        async getAccountInfoFun() {
            let res = await this.getAccountInfo({id: this.$route.params.id})
            for (const key in res) {
                if (this.ruleForm.hasOwnProperty(key) && res[key]) {
                    this.ruleForm[key] = res[key]
                }
            }
            this.selectList = res.permission_ids
            this.reViewQrcodeTileListValue()
        },
        getCheckAllStatus(data) {
            // this.indeterminate = false
            // this.checkAll = a
            // if(b) {
            //     this.indeterminate = true
            // }
        },
        async submitForm(type) {
            if(this.$route.name == 'EditSystem') {
                if(this.selectList.length) {
                    await this.editPermission({
                        id: this.$route.params.id,
                        permission_ids: this.selectList
                    })
                    this.$router.replace(this.staticPath + 'systemSettings')
                    this.$message({
                        type: 'success',
                        message: '修改成功',
                        duration: 3000
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: '请勾选该角色可以操作的模块',
                        duration: 3000
                    })
                }
                return
            }
            this.$refs[type].validate(async (valid, errorList) => {
                if(valid) {
                    if(this.$route.name == 'EditSystemInfo') {
                        await this.editAccount({...this.ruleForm, id: this.$route.params.id})
                        this.$router.replace(this.staticPath + 'systemSettings')
                        this.$message({
                            type: 'success',
                            message: '修改成功',
                            duration: 3000
                        })
                        return
                    }
                    if(this.selectList.length) {
                        await this.addAccount({
                            ...this.ruleForm,
                            permission_ids: this.selectList
                        })
                        this.$router.replace(this.staticPath + 'systemSettings')
                        this.$message({
                            type: 'success',
                            message: '添加成功',
                            duration: 3000
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: '请勾选该角色可以操作的模块',
                            duration: 3000
                        })
                    }
                }
            })
        }
    }
}
</script>
<style lang="less">
 @classNames: createSystem;
 .@{classNames} {
    .checkbox_group {
        .checkbox_group_con {
            // display: flex;
            // align-items: center;
			
        }
    }
	.checkbox_group{
		padding-left: 30px;
		border: 1px groove #e8e8e8;
		margin-bottom: -1px;
		margin-right: -1px;
	}
    .el-checkbox{
        margin: 10px 20px 10px 0;
    }
 }
 .check_checkAll{
 	
 }
 .check_checkList{
	 margin-left: -30px;
	 margin-bottom: 30px;
 }
.check_checkList > .checkbox_group{
	border: 0px groove #e8e8e8;
}
</style>
<style lang="less" scoped>
    @classNames: createSystem;
    .@{classNames}_inp {
        width: 320px;
    }
    .@{classNames}_title {
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        color: #37383c;
        box-sizing: border-box;
        padding-left: 10px;
        border-left: 4px solid #409eff;
        margin: 30px 0;
    }
    .select-qrcode-item{
        /deep/.el-form-item__label{
            width: 200px !important;
        }
        /deep/.el-select{
            width: 400px !important;
        }
        /deep/.el-form-item__error{
            margin-left: 40px !important;
        }
        .tip-text{
            color: #b7b7b7;
            font-size: 12px;
            margin-left: -100px;
        }
    }
    .no-reshow{
        /deep/ .el-input__inner {
            -webkit-text-security:disc!important;
        } 
    }
</style>